<template>
  <section>
    <gs-header title="Quản lý chặn tuyến đường">
      <router-link :to="{ name: 'create-blocks' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="blockTable" :table-name="blockTable" data-source="blocks" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-select v-model="filters.city_id" filterable placeholder="Chọn tỉnh thành" @change="getDistricts"
                class="width-100">
                <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="filters.district_id" filterable placeholder="Chọn quận huyện" @change="filter"
                class="width-100">
                <el-option v-for="district in districts" :key="district.id" :label="district.name" :value="district.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select class="display-block" v-model="suggettionPriceTable" filterable remote
                placeholder="Nhập tên bảng giá" :remote-method="selectPriceTable" :loading="fetchPriceTable"
                @change="selectSuggettionPriceTable">
                <el-option v-for="(item, index) in listPriceTable" :key="index" :value="item">
                  <span class="pull-left text-gray"><i class="fa fa-user"></i>&nbsp;{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </section>
        <section slot="inline-filters">
          <div class="text-middle" v-if="filters.price_table_id">
            <a @click.prevent="removePriceTable" class="ui teal tag label">{{ priceTable.name }}</a>
          </div>
          <div v-else>
            &nbsp;
          </div>
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[blockTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[blockTable].current_page - 1) * dataPaginations[blockTable].per_page)}}</small>
              </template>
            </el-table-column>

            <el-table-column label="Điểm giao/ lấy">
              <template slot-scope="scope">
                <p v-if="scope.row.district">{{ scope.row.district.data.fullname }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Bảng giá">
              <template slot-scope="scope">
                <p v-if="scope.row.price_table">{{ scope.row.price_table.data.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Chiều đi" width="100">
              <template slot-scope="scope">
                <div class="text-center">
                  <i class="fa fa-check text-green" v-if="scope.row.from"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Chiều đến" width="100">
              <template slot-scope="scope">
                <div class="text-center">
                  <i class="fa fa-check text-green" v-if="scope.row.to"></i>
                </div>
              </template>
            </el-table-column>

            <el-table-column width="50">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Xóa" class="display-inline">
                    <a @click.prevent="removeBlock(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
import ls from 'local-storage'
import { debounce, keys, forEach } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import { getAllPriceTables } from 'src/api/pricetable'
import { deleteBlock } from 'src/api/block'
export default {
  name: 'Block',
  data() {
    return {
      filters: {
        sort: 'created_at:-1',
        city_id: undefined,
        district_id: undefined,
        price_table_id: undefined,
        include: 'district,price_table'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      blockTable: 'blocks',
      suggettionPriceTable: {},
      fetchPriceTable: false,
      listPriceTable: []
    }
  },
  computed: {
    ...mapGetters('priceTable', ['priceTable']),
    ...mapGetters('city', ['cities']),
    ...mapGetters('district', ['districts']),
    ...mapGetters('block', ['block'])
  },
  methods: {
    ...mapActions('priceTable', ['setPriceTable']),
    ...mapActions('city', ['getAllCity']),
    ...mapActions('district', ['getDistrictByCityId']),
    ...mapActions('block', ['setBlock']),
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.blockTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.blockTable)
      }
    }, 300),
    removeFilter() {
      if (!this.checkDefaultFilter({
        sort: 'created_at:-1',
        city_id: undefined,
        district_id: undefined,
        price_table_id: undefined,
        include: 'district,price_table'
      })) {
        this.reloadGsTable(this.blockTable)
      }
      this.removePriceTable()
      this.filters = {
        sort: 'created_at:-1',
        city_id: undefined,
        district_id: undefined,
        price_table_id: undefined,
        include: 'district,price_table'
      }
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    removePriceTable() {
      this.filters.price_table_id = undefined
      this.filter()
    },
    getDistricts() {
      this.filter()
      this.filters.district_id = undefined
      this.getDistrictByCityId({ city_id: this.filters.city_id, limit: -1, sort: 'name:1' })
    },
    selectPriceTable(q) {
      if (q) {
        this.fetchPriceTable = true
        getAllPriceTables({ limit: 20, q: q, include: 'carrier,service,city_from,region_to' }).then(response => {
          if (response.code === 200) {
            this.listPriceTable = response.data
            this.fetchPriceTable = false
          }
        })
      }
    },
    selectSuggettionPriceTable() {
      this.setPriceTable(this.suggettionPriceTable)
      this.filters.price_table_id = this.suggettionPriceTable.id
      this.filter()
    },
    removeBlock(block) {
      this.setBlock(block)
      this.$confirm(`Bạn chắc chắn muốn xóa chặn tuyến đường này?`, 'Xóa chặn tuyến đường', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delBlock()
      }).catch(() => {

      })
    },
    delBlock() {
      deleteBlock(this.block.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa chặn tuyến đường thành công'
          })
          this.reloadGsTable(this.blockTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Xóa chặn tuyến đường thất bại'
          })
        }
      })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.blockTable]) {
      this.filters = ls.get('filters')[this.blockTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    if (this.$route.query['priceTable'] && this.priceTable.id) {
      this.filters.price_table_id = this.$route.query['priceTable']
      this.filter()
    }
    if (!this.cities.length) {
      this.getAllCity({ limit: -1, sort: 'name:1' })
    }

    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.blockTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['blocks']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped>
.border-right {
  border-right: 1px solid #dfe6ec;
}
</style>



// WEBPACK FOOTER //
// Block.vue?1e32c176